import VoyahTechnicalSpecsI18n from "../../Voyah/VoyahTechnicalSpecs/VoyahTechnicalSpecsI18n";
import tsImage from "../../../../assets/images/voyahtaishan/ts.png";

const VoyahTaishanTechnicalSpecs = () => (
  <VoyahTechnicalSpecsI18n
    page="voyahtaishan"
    variant="taishan"
    i18nPrefix="voyahTaishan"
    tsImage={tsImage}
    highlightKeys={["1", "2", "3", "4"]}
  />
);

export default VoyahTaishanTechnicalSpecs;
